import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { BillingStore, BillingState } from './billing.store';

@Injectable({ providedIn: 'root' })
export class BillingQuery extends QueryEntity<BillingState> {
  constructor(protected store: BillingStore) {
    super(store);
  }
}
